import { axiosPost } from './apiClient';

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/report`;

const getBusinessPerformanceReport = async ({
  period1From,
  period1To,
  period2From,
  period2To,
  branchId = null,
}) => {
  return await axiosPost(`${BASE_URL}/business-performance`, {
    period1From,
    period1To,
    period2From,
    period2To,
    branchId: branchId || null,
  });
};

const businessPerformanceReportApi = {
  getBusinessPerformanceReport,
};

export default businessPerformanceReportApi;
